import React from "react";
import CategoryForm from "./CategoryForm";
import { useParams } from "react-router-dom";
import BackDropFullScreen from "../../components/BackDropFullScreen";
import { useGetCategoryById } from "../../queries/useCategory";

function CategoryDetailPage() {
  const { categoryId } = useParams<{ categoryId: string }>();
  const { data: category, isLoading } = useGetCategoryById(
    parseInt(categoryId)
  );

  return (
    <div>
      <CategoryForm action={"DETAIL"} category={category} />
      <BackDropFullScreen isOpen={isLoading} />
    </div>
  );
}

export default CategoryDetailPage;
